module.exports = __webpack_public_path__ + "static/img/email.3ef3613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/email.png
// module id = 246
// module chunks = 1